module.exports = __webpack_public_path__ + "assets/img/aschool.df195665.png";